import history from '../history'
import { getLocationPath } from 'common/history'
import { isBrowser } from 'common/utils'
import typeChecker from 'common/typeChecker'

export const setScrollPositionHistory = (path: string) => {
  const position = {
    scrollX: window.pageXOffset,
    scrollY: window.pageYOffset,
  }
  const state = {
    ...(history.location && history.location.state),
    position,
  }
  history.replace(path, state)
}

export const getScrollPositionHistory = () => {
  if (history.location && history.location.state && history.location.state.position) {
    return history.location.state.position
  }

  return {
    scrollX: 0,
    scrollY: 0,
  }
}

export const scrollToHashElement = (location, type: 'hashChange' | 'load') => {
  const locationHash = location.hash
  if (!locationHash) {
    return
  }
  const targetHash = locationHash.substr(1)
  if (targetHash) {
    if (type === 'load' && targetHash.includes('scrollY=')) {
      const scrollY = Number(targetHash.split('=')[1])
      window.scrollTo(0, scrollY)
      return
    }
    moveScrollByElementId(targetHash)
  }
}

const scrollToHashScrollY = location => {
  const locationHash = location.hash
  if (!locationHash) {
    return
  }

  return false
}

export const moveScrollByElementId = (id, offset = 0) => {
  const target = document.getElementById(id)
  target && window.scrollTo(0, window.pageYOffset + target.getBoundingClientRect().top + offset)
}

export const moveScrollByHistory = (removedScroll = true) => {
  if (!isBrowser) return

  const position = getScrollPositionHistory()
  window.scrollTo(position.scrollX, position.scrollY)
  if (position.scrollX !== 0 || position.scrollY !== 0) {
    const state = {
      ...(history.location && history.location.state),
      position: {
        scrollX: 0,
        scrollY: 0,
      },
    }
    removedScroll && history.replace(getLocationPath(location), state)
  } else {
    scrollToHashElement(location, 'hashChange')
  }
}

export const moveScrollLeft = (el: HTMLElement, scrollLeft: number) => {
  if (!el || !typeChecker.isNumber(scrollLeft) || el.scrollLeft === scrollLeft) return
  el.scrollLeft = scrollLeft
}

export const moveScrollTop = (el: HTMLElement, scrollTop: number) => {
  if (!el || !typeChecker.isNumber(scrollTop) || el.scrollTop === scrollTop) return
  el.scrollTop = scrollTop
}
